import { useContext, useEffect } from 'react'
import { ModalContext } from '@nv/contexts'
import WarningIcon from '@nv/images/design/warning-icon'
import { useTranslation } from 'react-i18next'
import styles from './ConfirmDeleteFile.module.scss'

export const ConfirmDeleteFile = ({ onDelete }) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  useEffect(() => {
    setHeaderLabel(t('buttons.deleteFile'))
    setBtns([
      { text: t('buttons.cancel'), onClick: onClose, variant: 'secondary' },
      { text: t('buttons.delete'), onClick: onDelete },
    ])
  }, [])

  return (
    <div className={styles['container']}>
      <WarningIcon className={styles['warning-icon']} color={'var(--error-color)'} />
      <span>{t('buttons.confirmDelete')}</span>
    </div>
  )
}
